import Model from "@/models/Model"

export default class ADeactivate extends Model {
    resource() {
        return "deactivate"
    }
}